<template>
    <div class="hero" :style="{ backgroundImage: 'url(' + banner + ')' }">
        <b-container>
            <div class="hero__container pt-2 pt-lg-1" :class="{ 'hero__container--responsive': (backRoute !== undefined) && hideLogo }">
                <div class="hero__img mr-4" v-if="!hideLogo || (backRoute !== undefined)">
                    <router-link :to="backRoute" v-if="(backRoute !== undefined)" class="style--default">
                        <i class="fa fa-arrow-left fa-2x"></i>
                    </router-link>

                    <b-img v-if="icon === null && !hideLogo" ref="hero-img" :src="logo" :alt="title"
                           @error="$refs['hero-img'].src = DEFAULT_IMAGE"/>
                    <i :class="icon" class="fa-5x" v-if="icon !== null && !hideLogo"></i>
                </div>
                <div class="hero__content">
                    <slot name="title"><h1 class="hero__title" v-if="title">{{ title }}</h1></slot>
                    <section class="hero__subtitle">
                        <div v-if="subtitle" v-html="subtitle"></div>
                        <slot></slot>
                    </section>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
    import {DEFAULT_IMAGE} from '@/utils/constants'

    export default {
        name: 'hero',
        props: {
            banner: String,
            logo: String,
            title: String,
            subtitle: String,
            icon: {
                default: null,
                type: String
            },
            hideLogo: {
                default: false,
                type: Boolean
            },
            backRoute: Object
        },
        data: () => ({DEFAULT_IMAGE})
    }
</script>
